import { on } from "delegated-events";
import { mapStyles } from "@common/map-styles";
import "simplebar";
import "simplebar/dist/simplebar.css";

const data = JSON.parse(document.getElementById("map-locations").textContent);
const mapSidebar = document.querySelector(".map-sidebar");

const state = {
  currentInfoWindow: null,
  locations: [],
};

async function setupMap(mapEl) {
  const google = window.google;

  const { Map } = await google.maps.importLibrary("maps");
  const { LatLngBounds, Size } = await google.maps.importLibrary("core");
  const { Marker } = await google.maps.importLibrary("marker");
  const { InfoWindow } = await google.maps.importLibrary("streetView");

  const map = new Map(mapEl, {
    minZoom: 3,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    disableDefaultUI: true,
    zoomControl: true,
    scrollwheel: false,
    styles: mapStyles,
  });

  const handleDeselectLocation = () => {
    state.currentInfoWindow?.close();
    state.currentInfoWindow = null;
    mapSidebar.querySelector(".map-location-item.is-selected")?.classList.remove("is-selected");
  };

  const handleSelectLocation = (id) => {
    const location = state.locations.find((x) => x.id === id);
    const marker = location.marker;
    const infoWindow = location.infoWindow;

    map.panTo(marker.getPosition());
    map.panBy(0, -20);

    infoWindow.open({
      anchor: marker,
      map,
    });

    handleDeselectLocation();

    state.currentInfoWindow = infoWindow;

    const sidebarLocation = mapSidebar.querySelector(`.map-location-item[data-id="${id}"]`);

    sidebarLocation.classList.add("is-selected");

    if (mapSidebar.getAttribute("aria-expanded") === "true") {
      sidebarLocation.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  };

  const bounds = new LatLngBounds();

  data.forEach((location) => {
    const marker = new Marker({
      icon: {
        url: location.is_featured
          ? "/_resources/themes/app/dist/images/map-marker-dark.png"
          : "/_resources/themes/app/dist/images/map-marker.png",
        scaledSize: new Size(70, 84),
      },
      position: {
        lat: location.lat,
        lng: location.lng,
      },
      map,
    });

    const infoWindow = new InfoWindow({
      content: location.content,
      minWidth: 300,
    });

    infoWindow.addListener("closeclick", () => {
      handleDeselectLocation();
    });

    marker.addListener("click", () => {
      handleSelectLocation(location.id);
    });

    marker.addListener("mouseover", () => {
      marker.setZIndex(20);
    });

    marker.addListener("mouseout", () => {
      marker.setZIndex();
    });

    bounds.extend(marker.getPosition());

    state.locations.push({
      id: location.id,
      marker,
      infoWindow,
    });
  });

  let offset = 0;

  if (window.matchMedia("(min-width: 1024px)").matches) {
    offset = mapSidebar.offsetWidth;
    mapSidebar.setAttribute("aria-expanded", "true");
  }

  map.fitBounds(bounds, { left: offset });

  mapEl.parentNode.classList.remove("opacity-0");

  on("click", ".map-location-item", (e) => {
    const clickedId = parseInt(e.currentTarget.dataset.id);

    handleSelectLocation(clickedId);
  });

  on("click", ".map-sidebar-toggle", () => {
    if (mapSidebar.getAttribute("aria-expanded") === "false") {
      mapSidebar.setAttribute("aria-expanded", "true");
    } else if (mapSidebar.getAttribute("aria-expanded") === "true") {
      mapSidebar.setAttribute("aria-expanded", "false");
    }
  });

  on("click", ".map-info-window-close", () => {
    handleDeselectLocation();
  });
}

const mapEl = document.getElementById("google-map");

if (mapEl) {
  setupMap(mapEl);
}
